












































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositOverdraftInterestSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositOverdraftInterestSettings';
import AccountDepositOverdraftInterestSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/OverdraftInterest/AccountDepositOverdraftInterestSettingsEditDialog.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PeriodType from '@/models/Shared/PeriodType';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositOverdraftInterestSettingsRead', components: { AccountDepositOverdraftInterestSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;
    InterestRateType = InterestRateType;
    PeriodType = PeriodType;

    @Prop({required: true })
    settings: AccountDepositOverdraftInterestSettings;

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.settings.cumulativeRateValue - this.settings.rateValue;
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.settings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.settings.rateValue}%`;
    }

    async deleteDepositOverdraftInterestAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositOverdraftInterestSettings();
        }
    }

}
